import React from 'react';

type Props = {
  processOwner: string;
  processDescription: string;
};

const Header = (props: Props) => {
  const { processOwner, processDescription } = props;
  const typographyWithEmptyString = (text: string, emptyString: string) => {
    if (text) {
      return (
        <div className="process-map-v2-view-left-panel-header-non-empty-string">
          {text}
        </div>
      );
    } else {
      return (
        <div className="process-map-v2-view-left-panel-header-empty-string">
          {emptyString}
        </div>
      );
    }
  };

  return (
    <div className={'process-map-v2-view-left-panel-header'}>
      <div className={'process-map-v2-view-left-panel-header-content'}>
        <div className={'process-map-v2-view-left-panel-header-process-owner'}>
          Process Owner
        </div>
        <div
          className={
            'process-map-v2-view-left-panel-header-process-description'
          }
        >
          Process Description
        </div>
      </div>

      <div className={'process-map-v2-view-left-panel-header-details-content'}>
        <div className={'process-map-v2-view-left-panel-header-process-owner'}>
          {typographyWithEmptyString(
            processOwner,
            'Process Owner not yet defined'
          )}
        </div>
        <div
          className={
            'process-map-v2-view-left-panel-header-process-description'
          }
        >
          <div
            className={
              'process-map-v2-view-left-panel-header-description-typography'
            }
            title={processDescription}
          >
            {processDescription}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
